/**
 * Shared react-to-print page style for customer documents.
 *
 * Zero page margin because `DocumentSheet` carries its own 14mm padding; this
 * keeps the sheet on a single page instead of spilling onto a blank page 2.
 * `print-color-adjust` makes browsers keep the brand colour bar and tinted
 * total rows instead of stripping backgrounds. Paper size follows the tenant's
 * country (Letter in the US and Canada, A4 elsewhere).
 */
export function documentPageStyle(paper: 'A4' | 'Letter' = 'A4'): string {
  return `
  @page { size: ${paper}; margin: 0; }
  html, body { background: #ffffff !important; }
  * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
`;
}

/** A4 default, kept for callers without tenant context. */
export const DOCUMENT_PAGE_STYLE = documentPageStyle('A4');
